import useTitle from "../../../../hooks/useTitle";
import { GdkCheckpoint } from "@gdk/checkpoint";
import React, { useContext, useEffect } from "react";
import GeaoLayout from "../shared/Layout/GeaoLayout";
import { GeaoContext } from "../../GeaoContextProvider";
import { useNavigate } from "react-router-dom";

export default function ProducerApplicationInProgressOverview() {
    useTitle("Application Status");

    const { agentInterview } = useContext(GeaoContext);
    const navigate = useNavigate();

    useEffect(() => {
        new GdkCheckpoint({
            content: `#overview-checkpoint`,
            data: [
                {
                    title: "Create Profile",
                    status: "completed"
                },
                {
                    title: "Complete Application",
                    status: "in process"
                },
                {
                    title: "Pass Background Check",
                },
                {
                    title: "Start Selling with GEICO",
                }
            ],
            animated: false
        });
    }, []);

    return (
        <GeaoLayout header="Application Status">
            <div className="margin-top margin-bottom container">
                <p className="font--bold" style={{ color: "#616161" }}>Your application is in progress.</p>
                <h3>Welcome back, {agentInterview?.questionAnswers?.FirstName?.answer}.</h3>

                <div className="bordered-box w-100 p-1 margin-top">
                    <div className="flex-row">
                        <div className="checkpoint p-3 m-2 background overview-block" id="overview-checkpoint" style={{ flexBasis: "375px", flexGrow: 0, flexShrink: 0 }}>
                            <p className="checkpoint checkpoint-heading">What's Next?</p>
                            <ul className="checkpoint-content"></ul>
                        </div>
                        <div className="m-2">
                            <h4 className="margin-top margin-bottom">Have these details ready before you complete your application:</h4>
                            <gds-list-wrapper type="bullet-list">
                                <gds-simple-list-item type="bullet-list">Your Principal Role Info</gds-simple-list-item>
                                <gds-simple-list-item type="bullet-list">Office and Employee Info</gds-simple-list-item>
                                <gds-simple-list-item type="bullet-list">Agency Financial Details</gds-simple-list-item>
                                <gds-simple-list-item type="bullet-list">E&O and W-9 Documentation</gds-simple-list-item>
                            </gds-list-wrapper>
                            <p className="margin-top">
                                You’ll provide an electronic signature to confirm and submit your application.
                            </p>
                        </div>
                    </div>

                    <p className="mx-auto margin-top">This task will take about 30–45 minutes.</p>
                    <div className="mx-auto">
                        <button className="btn btn--primary" onClick={() => navigate('/onboarding-agent-personal-information')}>
                            Complete Application
                        </button>
                    </div>
                </div>
            </div>
        </GeaoLayout>
    );
}